
export const ServerURLs = Object.freeze({
    localhost:  'http://127.0.0.1:8080', // working locally with server
    production: 'https://web.vibo.io/api', // goes through AWS Lambda Edge that redirects to 'https://server.prod.vibo.io' (the mobile app uses this address)
    staging:    'https://stageserver.prod.vibo.io', // goes through AWS Lambda Edge that redirects to 'https://server.prod.vibo.io' (the mobile app uses this address)
});

export const ScannerAPIURLs = Object.freeze({
    staging:    'https://scanner.stage.vibo.io', // directs to staging scanner API
    production: 'https://scanner.prod.vibo.io', // directs to production scanner API
});

export const EventType = Object.freeze({
    WEDDING:        "Wedding",
    MITZVAH:        "Mitzvah",
    PARTY:          "Party",
    SCHOOL:         "School Dance",
    CORPORATE:      "Corporate",
    FESTIVAL:       "Festival",
    ANNIVERSARY:    "Anniversary",
    BIRTHDAY:       "Birthday",
});

export const SectionPrivacyType = Object.freeze({
    PRIVATE:    "private",
    PUBLIC:     "public",
});

export const InputTypes = Object.freeze({
    SHORT_ANSWER:   "ShortAnswer",
    LONG_ANSWER:    "LongAnswer",
    CHECK_BOX:      "CheckBox",
    OPTIONS_LIST:   "OptionsList",
    DROPDOWN_LIST:  "DropdownList",
    HEADER:         "Header",
    FREE_TEXT:      "FreeText",
});

export const MusicInputTypes = Object.freeze({
    ONE_SONG:   "OneSong",
    SONG_LIST:  "SongList",
    NON_MUSIC:  "NonMusic",
});

export const PageNames = Object.freeze({
    EVENTS:             "sidemenu.myEventsText",
    TEMPLATES:          "sidemenu.templatesText",
    RECOMMENDATIONS:    "sidemenu.recommendationsText",
    INFO:               "sidemenu.userInfoText",
    GALLERY:            "sidemenu.myGalleryText"
});

export const MarkedTypes = Object.freeze({
    MUST_PLAY:      "mustPlay",
    DONT_PLAY:      "dontPlay",
    HOST_LIKED:     "hostLiked",
    UNMARK:         "",
    SPECIAL_SONG:   "specialSong",
});

export const DeleteTypes = Object.freeze({
    TEMPLATE:   "template",
    SECTION:    "section",
    EVENT:      "event",
    CONTACT:    "contact"
});

export const PicTypes = Object.freeze({
    PROFILE:        "picType.profile",
    COVER:          "picType.cover",
    LOGO:           "picType.logo",
    TEMPLATE:       "picType.template",
    EVENT_COVER:    "picType.eventCover"
});

export const SongViews = Object.freeze({
    SECTIONS:   "sections",
    ALL:        "all"
});

export const UserRole = Object.freeze({
    VIBO_ADMIN: "Vibo-Admin",
    ADMIN:      "Admin",
    DJ:         "DJ"
});

export const TemplatePageViewState = Object.freeze({
    NONE:           "None",
    PLANNING_FORM:  "Planning Form",
    MUSIC_SECTIONS: "Music Sections"
});

export const ScannerTypes = Object.freeze({
    MAC:        "Macbook",
    WINDOWS:    "Windows"
});

export const EventDetailsGroups = Object.freeze({
    GENERAL:    "General",
    CONTACTS:   "Contacts",
    ADVANCED:   "Advanced"
});

export const ContactDialogState = Object.freeze({
    NEW:    "New",
    EDIT:   "Edit"
});

export const ContactGenderImgPath = Object.freeze({
    MALE:   "https://s3.eu-central-1.amazonaws.com/vibo-public/wwwroot/images_static/male_avatar.svg",
    FEMALE: "https://s3.eu-central-1.amazonaws.com/vibo-public/wwwroot/images_static/female_avatar.svg"
});

export const ContactGender = Object.freeze({
    MALE: "male",
    FEMALE: "female"
});

export const AccountStatus = Object.freeze({
    LIMITED:    'Limited',
    TRIAL:      'Trial',
    ACTIVATED:  'Activated',
    ADMIN:      'Admin',
});

export const Region_Language = Object.freeze({
    ENGLISH_US:     "en_US",
    HEBREW_IL:      "he_IL",
    SPANISH:        "la_ES",
    NO_MENS_LAND:   "xx_XX"
});

export const ViboSubscriptionPlan = Object.freeze({
    MONTHLY_PLAN:   "MONTHLY_PLAN",
    ANNUALLY_PLAN:  "ANNUALLY_PLAN",
    ALL:            "All"
});

export const ViboSubscriptionAmount = Object.freeze({
    ANNUALLY_PLAN:              997, // current annually plan
    ANNUALLY_PLAN_PREVIOUS_2:   1197,
    ANNUALLY_PLAN_PREVIOUS_1:   397,
    MONTHLY_PLAN:               99,  // current monthly plan
    MONTHLY_PLAN_PREVIOUS_2:    119,
    MONTHLY_PLAN_PREVIOUS_1:    36,
});

export const CouponDuration = Object.freeze({
    FOREVER:            'forever',  // constant discount for every iteration (monthly/yearly)
    ONCE:               'once',     // one time
    MULTIPLE_MONTHS:    'multiple months', // discount for a specific months number - currently not supported
});

export const TemplateEditState = Object.freeze({
    EVENT_SETTINGS: 'EVENT_SETTINGS',
    EVENT_SECTIONS: 'EVENT_SECTIONS',
    PLANNING_FORMS: 'PLANNING_FORMS'
});

export const EventDefaultSettings = Object.freeze({
    NUM_OF_SONGS_LIMIT_MIN:     0,
    NUM_OF_SONGS_LIMIT_MAX:     200,
    NUM_OF_SONGS_LIMIT_DEFAULT: 60,
    DAYS_TO_LOCK_EVENT_MIN:     0,
    DAYS_TO_LOCK_EVENT_MAX:     30,
    DAYS_TO_LOCK_EVENT_DEFAULT: 2,
});

export const SectionType = Object.freeze({
    SINGLE_SONG: 'Special Song',
    SONG_LIST: 'Song List',
    ACTIVITY: 'Non Music',
});

export const Spotify = Object.freeze({
    AUTH_POPUP: {
        URL: (viboBaseUrl, scope) => 'https://accounts.spotify.com/authorize?' +
            'client_id=d6f5c152f33049cabb8e9cef3ed44ec5' +
            '&response_type=token' +
            '&redirect_uri=' + viboBaseUrl + '/auth/spotify/callback' +
            (scope ? ('&scope=' + scope.join('%20')) : '') +
            '&show_dialog=true',
        TITLE: 'Spotify Auth',
        WIDTH: 500,
        HEIGHT: 685,
        TESTING_REDIRECT_BASE_URL: 'http://localhost:3000'
    },
    LOGO: {
        WIDTH: 24,
        HEIGHT: 24
    },
    SPOTIFY_API: {
        BASE_URL: 'https://api.spotify.com/v1',
        SEARCH_TYPE: 'playlist',
        PLAYLISTS_LIMIT: 50,
        HEADERS: {
            AUTHORIZATION: 'Bearer ',
            CONTENT_TYPE: 'application/json',
            ACCEPT: 'application/json'
        },
        SCOPE: {
            PLAYLIST_MODIFY_PUBLIC: 'playlist-modify-public',
            PLAYLIST_READ_PRIVATE: 'playlist-read-private',
            PLAYLIST_READ_COLLABORATIVE: 'playlist-read-collaborative'
        },
        DEFAULT_PLAYLIST_IMAGE_URL: 'https://vibo-public.s3.eu-central-1.amazonaws.com/wwwroot/images_static/default_spotify_playlist_image.jpg'
    }
});

export const Youtube = Object.freeze({
    LOGO: {
        WIDTH: 26,
        HEIGHT: 26
    }
});

export const Messenger = Object.freeze({
    LOGO: {
        WIDTH: 24,
        HEIGHT: 24
    }
});



// WEBPACK FOOTER //
// ./src/utils/enumUtils.js